import React, { useEffect, useState } from 'react'

import { useDisconnectIGMutation, useLazyGetChannelsQuery } from './apiSlice'

import ReactModal from 'react-modal';
import styles from './styles'
import { useLazyGetProfileQuery } from '@Pages/Profile/apiSlice'
import posthog from 'posthog-js'
import { AnalyticsParamBuilder, clientId, redirectPath, responseType, scope } from "@Utils/common";


const COMPONENT = "instagram_accounts"

const Channels = () => {

  const [disconnectModal, setDisconnectModal] = useState(false)
  const [disconnectChannelData, setDisconnectChannelData] = useState({
    igpid: '-1',
    ig_id: '-1',
    ig_username: ''
  })

  const [getChannels, { data: channelsData, isLoading: isChannelsLoading }] = useLazyGetChannelsQuery()

  const [getProfile, { data: getProfileDataResponse }] = useLazyGetProfileQuery();

  const closeDisconnectModal = () => {
    posthog.capture("ui_action", AnalyticsParamBuilder({
      kingdom: COMPONENT,
      phylum: "cancel_disconnect_ig_account",
      classValue: disconnectChannelData?.ig_id,
      genus: disconnectChannelData?.ig_username,
      int_value: Number(disconnectChannelData?.igpid),
    }));
    setDisconnectModal(!disconnectModal)
  }

  useEffect(() => {
    getChannels({})
  }, [])

  useEffect(() => {
    getProfile({})
  }, [channelsData])

  const onDisconnectBtnClick = (ig_app_id: string, ig_id: string, ig_username: string) => {
    posthog.capture("ui_action", AnalyticsParamBuilder({
      kingdom: COMPONENT,
      phylum: "disconnect_ig_account",
      classValue: ig_id,
      genus: ig_username,
      int_value: Number(ig_app_id),
    }));
    posthog.capture("ui_view", AnalyticsParamBuilder({
      kingdom: COMPONENT,
      phylum: "modal",
      classValue: "disconnect_ig_account",
      genus: ig_id,
      str_value: ig_username,
      int_value: Number(ig_app_id),
    }));
    setDisconnectModal(true)
    setDisconnectChannelData({
      igpid: ig_app_id,
      ig_id,
      ig_username
    })
  }

  const refreshChannelData = () => {
    getChannels({})
  }



  const handelRefreshButtonClick = (ig_username: string, ig_id: string, ig_app_id: string) => {
    posthog.capture("ui_action", AnalyticsParamBuilder({
      kingdom: COMPONENT,
      phylum: "refresh_ig_token",
      classValue: ig_id,
      genus: ig_username,
      int_value: Number(ig_app_id),
    }));

    // Construct the redirect URL dynamically using the current origin
    const redirectUri = `${window.location.origin}${redirectPath}`;

    const authUrl = `https://www.instagram.com/oauth/authorize?force_reauth=true&client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=${responseType}&scope=${encodeURIComponent(scope)}`;

    // console.log(redirectUri)
    // Redirect the user to the dynamically constructed URL
    window.location.href = authUrl;
  }



  return (
    <div>
      <div className='w-full'>
        {isChannelsLoading ? (
          <div className="px-2 py-8 text-sm text-gray-500">Loading accounts...</div>
        ) : (
          <div className='grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4'>
            {channelsData?.channel?.instagram?.map((el: any) => {
              return (
                <div key={el.instagram_id || el.igsid} className='flex min-h-[360px] flex-col rounded-2xl border border-slate-200 bg-white p-6 shadow-sm'>
                  <div className='mb-5 flex justify-center'>
                    <img
                      className='h-28 w-28 rounded-full border border-slate-100 object-cover'
                      src={el.profile_picture_url}
                      alt={el.username}
                    />
                  </div>
                  <div className='flex flex-1 flex-col text-center'>
                    <p className='break-words text-2xl font-bold text-slate-900'>{el.username}</p>
                    <p className='mt-1 break-words text-base text-slate-600'>{el.name}</p>
                    <div className='mt-auto space-y-3 pt-6'>
                      <button
                        className="w-full rounded-lg bg-[#ef4444] px-6 py-2 text-white transition-colors hover:bg-[#dc2626]"
                        onClick={() => onDisconnectBtnClick(el.instagram_id, el.igsid, el.username)}
                      >
                        Disconnect
                      </button>
                      <button
                        className="w-full rounded-lg bg-green-500 px-6 py-2 text-white transition-colors hover:bg-green-600"
                        onClick={() => handelRefreshButtonClick(el.username, el.igsid, el.instagram_id)}
                      >
                        Refresh Token
                      </button>
                    </div>
                  </div>
                </div>
              )
            })}
            {!channelsData?.channel?.instagram?.length && (
              <div className="rounded-2xl border border-dashed border-slate-300 bg-slate-50 px-6 py-10 text-center text-slate-500">
                No Instagram accounts connected yet.
              </div>
            )}
          </div>
        )}
      </div>
      <DeleteAutomationModal isModalOpen={disconnectModal} disconnectModalOnClose={closeDisconnectModal} disconnectChannelData={disconnectChannelData} refreshChannel={refreshChannelData} />
    </div>
  )
}



interface DeleteAutomationModalInterface {
  isModalOpen: boolean;
  disconnectModalOnClose: () => void;
  disconnectChannelData: any
  refreshChannel: () => void;
}


const DeleteAutomationModal = (props: DeleteAutomationModalInterface) => {

  const [disconnectIG, { data: disconnectIGData, error: disconnectIGErr, isLoading: isDisconnectIGLoading }] = useDisconnectIGMutation()


  useEffect(() => {
    if (disconnectIGData) {
      props.disconnectModalOnClose()
      props.refreshChannel()
    }
    if (disconnectIGErr) console.log(disconnectIGErr);
  }, [disconnectIGData, disconnectIGErr])

  const disconnectBtnClick = (e: any) => {
    posthog.capture("ui_action", AnalyticsParamBuilder({
      kingdom: COMPONENT,
      phylum: "confirm_disconnect_ig_account",
      classValue: props.disconnectChannelData?.ig_id,
      genus: props.disconnectChannelData?.ig_username,
      int_value: Number(props.disconnectChannelData?.igpid),
    }));

    disconnectIG(props.disconnectChannelData)
  }


  return (
    <ReactModal
      isOpen={props.isModalOpen}
      onRequestClose={props.disconnectModalOnClose}
      style={
        { overlay: {}, content: styles.deleteContactModalContent }
      }
      portalClassName={"ReactModalPortal"}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      role={"dialog"}
      preventScroll={false}
    >
      <>
        <div className="pb-[.5rem] border-b-2 border-slate-300" style={styles.modalHeader}>
          <h3>Confirm</h3>
        </div>
        <div className="py-[1rem]" style={styles.modalContent}>
          <p>Are you sure to disconnect this channel?</p>
          <div className="flex justify-end mt-[2rem]">
            <button className="px-6 py-1 border-2 border-solid rounded" style={styles.redButton} onClick={disconnectBtnClick} disabled={isDisconnectIGLoading}>Disconnect</button>
            <button
              className="px-6 py-1 border-2 border-solid rounded border-green-500 mx-2 w-[150px]"
              style={styles.greenButton}
              onClick={props.disconnectModalOnClose}>
              Cancel
            </button>
          </div>
        </div>
      </>
    </ReactModal>
  )
}

export default Channels
